$(function() {
    if($('#body form').length > 0){
        let $fields = $('.acf-form-fields'),
            errorHeight = 0,
            fieldHeight = $fields.outerHeight()

        // floating label on select for pre-selected option
        $('select').each(function() {
            let $this = $(this)

            if($this.val() !== ''){
                $this.parent().prev('.acf-label').addClass('active')
            }
        })

        // floating label on input
        var $inputs = $('input, textarea, select')

        $inputs.on('focus click', function(){
            let $this = $(this),
                $label = $this.parents('.acf-input').prev('.acf-label')

            $label.addClass('active')
        })

        $inputs.on('blur', function(){
            let $this = $(this),
                $label = $this.parents('.acf-input').prev('.acf-label')

            if($this.val() === ''){ $label.removeClass('active') }
        })

        $inputs.on('input autocomplete', function() {
            let $this = $(this),
                $formFields = $('.acf-form-fields.active'),
                $label = $this.parents('.acf-input').prev('.acf-label'),
                newHeight = 0,
                $error

            if($this.parent('.acf-input-wrap').prev('.acf-error-message').length > 0) { // Most input types
                $error = $this.parent('.acf-input-wrap').prev('.acf-error-message')
            } else if($this.parents('.acf-true-false').prev('.acf-error-message').length > 0) { // Exception for checkboxes
                $error =  $this.parents('.acf-true-false').prev('.acf-error-message')
            }

            // Remove errors on input
            if(!!$error && $error.length === 1) {
                newHeight = $error.outerHeight()

                if(newHeight > 0) {
                    $('.acf-error').each(function(k, v){
                        let $this = $(this)

                        // Remove height is sized input
                        // Only add one inline field height
                        if($this.hasClass('sized-input') && $this.siblings('.sized-input.acf-error').length !== 0){ newHeight = 0 }

                        if($this.find('input').val() !== '') {
                            errorHeight = errorHeight + newHeight
                        }
                    })

                    let newFieldHeight = $formFields.height() - errorHeight

                    if(newFieldHeight >= fieldHeight) {
                        $formFields.animate({height: newFieldHeight })
                    } else {
                        $formFields.animate({height: fieldHeight })
                    }
                }

                if($this.closest('.acf-field').css('min-height') !== '0px') {
                    $this.closest('.acf-field').css('min-height', '')
                }

                $this.closest('.acf-field').removeClass('acf-error')
                $this.removeClass('skipHeight')
                $error.remove()
            }

            if($this.val() !== ''){
                $label.addClass('active')
            } else {
                $label.removeClass('active')
            }
        })

        // Reset error height
        $('.progress-button').on('click', function() {
            errorHeight = 0,
            fieldHeight = $fields.outerHeight() // capture new height
        })
    }
})